import moment from 'moment';

const state = {
    orders: [],
    ready: false
}

const getters = {
    current: state => {
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        return state.orders.filter(c => moment(c.endDate).toDate() > today);
    },
    planTypes: (state, getters) => {
        let items = getters.current.map(o => o.items.map(i => i.item));
        return _.flatten(items);
    }
}

const actions = {
    async load({ commit, rootState }, data) {
        commit('setReady', false);
        let employerId = rootState.employer.employerId;
        if(data && data.employerId) employerId = data.employerId;
        if(!employerId) return;

        let orders = await romeApi.get(`employer/${employerId}/order`);
        commit('setOrders', orders);
        commit('setReady', true);
    }
}

const mutations = {
    setOrders(state, data) {
        data = data.map(d => {
            var s = d.items.map(i => i.item);
            d.services = s.join();
            return d;
        });

        state.orders = [...data];
    },
    setReady(state, data) {
        state.ready = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/employer/x-employer-contracts.js